import type { IContactPersonEmploymentSubTypes } from './ContactPersonEmploymentSubTypes.interface';

export default class ContactPersonEmploymentSubTypes
  implements IContactPersonEmploymentSubTypes {
  onBenefits: boolean;
  student: boolean;
  homeDuties: boolean;

  static build = (data: IContactPersonEmploymentSubTypes) =>
    new ContactPersonEmploymentSubTypes(data);

  static blank = () => new ContactPersonEmploymentSubTypes();

  /**
   * Constructor
   * @param {IContactPersonEmploymentSubTypes} data
   */
  constructor(data?: IContactPersonEmploymentSubTypes) {
    this.onBenefits = data?.onBenefits === true;
    this.student = data?.student === true;
    this.homeDuties = data?.homeDuties === true;
  }
}
